import React, { memo } from 'react';
import { bool, func, number, object } from 'prop-types';
import MapPinIcon from '../../../resources/images/map-pin-general.png';
import MapPinIconSelected from '../../../resources/images/map-pin-selected-general.png';
import MapPinSpecialtyIconSelected from '../../../resources/images/map-pins-specialty-location-selected.png';
import MapPinSpecialtyIcon from '../../../resources/images/map-pins-specialty-location.png';
import { dstDataLocators } from '../dataLocators';

const Marker = props => {
    // const { pc, selectedStoreValue, onClickMarker, setFocusedLocation, itemData } = props;
    const { pc, itemData, onClickMarker, setFocusedLocation, selectedStoreValue, isSpecialty } = props;

    const onMarkerClick = () => {
        onClickMarker(pc, itemData?.companyId);
        setFocusedLocation({ lat: itemData?.latitude, long: itemData?.longitude });
    };
    const isPinSelected = pc == selectedStoreValue;
    const getPinType = () => {
        if (isPinSelected) {
            if (isSpecialty) {
                return MapPinSpecialtyIconSelected;
            }
            return MapPinIconSelected;
        } else {
            if (isSpecialty) {
                return MapPinSpecialtyIcon;
            }
            return MapPinIcon;
        }
    };

    return (
        <>
            <img
                src={getPinType()}
                alt="marker"
                className={isPinSelected ? 'mapIcon selectedMapIcon' : 'mapIcon'}
                onClick={onMarkerClick}
                data-testid={dstDataLocators.dst_map_marker}
            />
        </>
    );
};
Marker.propTypes = {
    pc: number,
    itemData: object,
    onClickMarker: func,
    setFocusedLocation: func,
    selectedStoreValue: number,
    isSpecialty: bool
};

Marker.defaultProps = {
    pc: null,
    itemData: {},
    onClickMarker: () => {},
    setFocusedLocation: () => {},
    selectedStoreValue: null,
    isSpecialty: false
};
export default memo(Marker);
